import { BaseDto } from "./base.dto"

import { PagingDto } from "./paging.dto"
import { ProductDetailDto, ProductDto } from "./product.dto"

export class AdminFindFlashSaleDto extends PagingDto {
  searchText?: string
  status: string
}

export class AdminFindFlashSaleItemDto extends PagingDto {
  status: string
  tenantId?: string
}

export class AdminFlashSaleItemDto extends BaseDto {
  productId: string
  tenantId: string
  product: ProductDetailDto
  status: string
}

export class AdminFlashSaleDto extends BaseDto {
  name: string
  nameKh: string
  minDiscount: number
  discountType: string = 'percentage'
  status: string
  numberOfTenants: number
  startTime: Date
  endTime: Date
  enabled: boolean
  hasNew: boolean

  static create() {
    return new AdminFlashSaleDto()
  }
}

export class AdminCreateFlashSaleDto {
  name: string
  nameKh: string
  minDiscount: number
  startTime: Date
  endTime: Date
  imageId?: string
  mobileImageId?: string
}

export class AdminUpdateFlashSaleDto {
  name?: string
  nameKh?: string
  minDiscount?: number
  startTime?: Date
  endTime?: Date
  imageId?: string
  mobileImageId?: string
}

export enum FlashSaleStatus {
  Upcoming = 'upcoming',
  Ongoing = 'ongoing',
  Expired = 'expired'
}